import { Box, Flex, FormHeading, Text, Tooltip } from "atoms";
import { usePropsoch } from "contexts/Propsoch";
import {
  MasterPlanForm,
  SiteChallengesForm,
  TowerUnitPlansForm,
  UnitDetailForm,
} from "molecules";

import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { PLOT, PROPERTY_STATUS, VILLA } from "utils/constants";

export const DesignAnalysis = ({
  onNext,
  onPrevious,
  bindHitOnSave,
  fetchProperty,
  rootProperty,
}) => {
  const {
    actions: { getPropertyListingTowerUnitDetails },
  } = usePropsoch();

  const { id } = useParams();
  // fetch property
  const [property, setProperty] = useState({});

  useEffect(() => {
    id &&
      getPropertyListingTowerUnitDetails(id)?.then((data) => {
        setProperty(data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const [type, setType] = useState(0);
  const tabs = useMemo(
    () => [
      {
        name: "Master Plan",
        status: true,
      },
      {
        name: "Site Challenges",
        status: rootProperty?.[PROPERTY_STATUS.masterPlan],
      },
      ...(!rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(PLOT) &&
      !rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(VILLA)
        ? [
            {
              name: "Tower Unit Plans",
              status: rootProperty?.[PROPERTY_STATUS.siteChallanges],
            },
          ]
        : []),
      {
        name: "Unit Details",
        status:
          rootProperty?.[PROPERTY_STATUS.masterPlan] &&
          rootProperty?.[PROPERTY_STATUS.siteChallanges] &&
          (rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(PLOT) ||
          rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(VILLA)
            ? rootProperty?.[PROPERTY_STATUS.siteChallanges]
            : rootProperty?.[PROPERTY_STATUS.towerUnitPlan]),
      },
    ],
    [rootProperty]
  );
  const [isActiveTab, setActiveTab] = useState("Master Plan");

  // const onMasterPlanSubmit = () => {
  //   setType(1);
  //   setActiveTab("Site Challenges");
  // };
  // const onSiteChallangeSubmit = () => {
  //   setType(2);
  //   setActiveTab("Tower Unit Plans");
  // };
  // const onTowerUnitSubmit = () => {
  //   setType(3);
  //   setActiveTab("Unit Details");
  // };

  return (
    <Box style={{ overflowWrap: "anywhere" }}>
      <FormHeading text="Design Analysis" />
      <Flex
        alignItems="center"
        borderBottom=".5px solid"
        borderColor="neutral.200"
        mt="1.6rem"
      >
        {tabs.map((item, index) => (
          <Box key={index}>
            <Tooltip
              render={item?.status ? "" : `${tabs?.[index - 1]?.name} required`}
              maxWidth="none !important"
              isTooltipArrow
              // {...tooltipProps}
            >
              <Text
                color={type !== index ? "neutral.400" : "neutral.800"}
                fontFamily="NeometricBold"
                onClick={
                  item?.status
                    ? () => {
                        setType(index);
                        setActiveTab(item?.name);
                      }
                    : undefined
                }
                borderBottom={type === index ? "2px solid" : "none"}
                borderColor="secondary.700"
                p="1rem 1.8rem"
                cursor="pointer"
              >
                {item?.name}
              </Text>
            </Tooltip>
          </Box>
        ))}
      </Flex>
      {isActiveTab === "Master Plan" && (
        <MasterPlanForm
          onNext={() => {
            // onNext();
            setType(1);
            setActiveTab("Site Challenges");
          }}
          onPrevious={onPrevious}
          bindHitOnSave={bindHitOnSave}
          fetchProperty={fetchProperty}
          rootProperty={rootProperty}
        />
      )}
      {isActiveTab === "Site Challenges" && (
        <SiteChallengesForm
          onNext={() => {
            // onNext();
            if (
              !property?.propertyType?.includes(PLOT) &&
              !property?.propertyType?.includes(VILLA)
            ) {
              setType(2);
              setActiveTab("Tower Unit Plans");
            } else {
              setType(2);
              setActiveTab("Unit Details");
            }
          }}
          onPrevious={onPrevious}
          bindHitOnSave={bindHitOnSave}
          fetchProperty={fetchProperty}
          rootProperty={rootProperty}
        />
      )}
      {!property?.propertyType?.includes(PLOT) &&
        !property?.propertyType?.includes(VILLA) &&
        isActiveTab === "Tower Unit Plans" && (
          <TowerUnitPlansForm
            onNext={() => {
              // onNext();
              setType(3);
              setActiveTab("Unit Details");
            }}
            onPrevious={onPrevious}
            bindHitOnSave={bindHitOnSave}
            fetchProperty={fetchProperty}
            rootProperty={rootProperty}
          />
        )}
      {isActiveTab === "Unit Details" && (
        <UnitDetailForm
          onNext={onNext}
          onPrevious={onPrevious}
          bindHitOnSave={bindHitOnSave}
          fetchProperty={fetchProperty}
          rootProperty={rootProperty}
        />
      )}
    </Box>
  );
};
